export default __webpack_public_path__ + "static/media/icon-chat-feedback.ee5cfbdd.svg";